export default {
  FeatureYear2023(): boolean {
    if (process.env.VUE_APP_YEAR_2023 == 1) {
      return true;
    } else {
      return false;
    }
  },
};
